import { render, staticRenderFns } from "./ExperienceGroup.vue?vue&type=template&id=a19ddc22&scoped=true"
import script from "./ExperienceGroup.vue?vue&type=script&lang=js"
export * from "./ExperienceGroup.vue?vue&type=script&lang=js"
import style0 from "./ExperienceGroup.vue?vue&type=style&index=0&id=a19ddc22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19ddc22",
  null
  
)

export default component.exports